module.exports = __webpack_public_path__ + "img/jiangyin.65b115c.png";